import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import Login from "../components/auth/login";
import LoginCallback from "../components/auth/login/LoginCallback";
import Dashboard from "../features/dashboard";
import Layout from "../features/layout/layout";
import ToastNotification from "../components/common/toastNotification";
import PageLoader from "../components/common/PageLoader";
import { useSelector } from "react-redux";
import CompanyAddressPage from "../features/companyAddress&About/companyAddress";
import { LoginRootState } from "../types/login";
import AdminSection from "../features/adminSection";
import ReImagineDashboard from "../features/adminSection/ReImagineDashboard";
import RandRDashboard from "../features/adminSection/R&RDashboard";
import Policies from "../features/policies";
import BudgetListingView from "../features/adminSection/BudgetListingView";
import RRApprovalList from "../features/dashboard/ApprovePendingList/R&RApprovalList";
import REImagineSubmitList from "../features/dashboard/REimagineSubmitDraftListing/REImagineSubmitList";
import PolicyDashbaoard from "../features/adminSection/Policy/PolicyDashbaoard";
import ApprovedIdeasDashboardSPOC from "../features/dashboard/SPOCApprIdeasDashboard";
import BikeDiscountDashboard from "../features/adminSection/BikeDiscount/BikeDiscountDashboard";
import BikeDiscountErrorLogDashboard from "../features/adminSection/BikeDiscount/BikeDiscountErrorLogDashboard";
import BikeDiscountApprovalLinkPage from "../features/layout/BikeDiscountApprovalLinkPage";

const RouteStart: React.FC = () => {
  return (
    <Router>
      <PageLoader />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/auth/callback" element={<LoginCallback />} />
        {/* Public Bike Discount Approval Link (no login required) */}
        <Route element={<Layout />}>
          <Route
            path="/bike-discount/approval"
            element={<BikeDiscountApprovalLinkPage />}
          />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/companyAddress" element={<CompanyAddressPage />} />
          <Route path="/adminSection" element={<AdminSection />} />
          <Route path="/reImagineDashboard" element={<ReImagineDashboard />} />
          <Route path="/RandRDashboard" element={<RandRDashboard />} />
          <Route path="/BudgetDashboard" element={<BudgetListingView />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/policyDashboard" element={<PolicyDashbaoard />} />
          <Route path="/approvalPendingList" element={<RRApprovalList />} />
          <Route
            path="/implementation-pendingView"
            element={<ApprovedIdeasDashboardSPOC />}
          />
          <Route
            path="/reimagineSubmittedList"
            element={<REImagineSubmitList />}
          />
          <Route
            path="/bikeDiscountDashboard"
            element={<BikeDiscountDashboard />}
          />
          <Route
            path="/bikeDiscountErrorLog"
            element={<BikeDiscountErrorLogDashboard />}
          />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>

        {/* Redirect unknown routes */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <ToastNotification />
    </Router>
  );
};

//// Fixed Private Route with Proper Rendering
const PrivateRoute: React.FC = () => {
  const loginDetails = useSelector(
    (state: LoginRootState) => state.authReducer.loginDetials
  );

  const token = loginDetails?.authToken;

  const isAuthenticated = token && token !== "undefined" && token !== "null";

  if (!isAuthenticated) {
    localStorage.setItem("postLoginRedirect", window.location.href);
    return <Navigate to="/" />;
  }

  return isAuthenticated ? (
    <Layout>
      <Outlet />
    </Layout>
  ) : (
    <Navigate to="/" />
  );
};

export default RouteStart;
